export default __webpack_public_path__ + "static/media/bonnitas-Fresitas.1f5317c0.jpg";